import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/core/plugins/i18n";
import ApiService from "@/core/services/ApiService";
import UserService from "@/core/services/UserService";
import { useUserSettingsStore } from "@/store/pinia/UserSettingsModule";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import Toast, { PluginOptions } from "vue-toastification";
import FloatingVue from "floating-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import "@/core/plugins/prismjs";
import "@/assets/css/main.css";
import "@/assets/css/report.css";
import "@imengyu/vue3-context-menu/lib/vue3-context-menu.css";
import "vue-toastification/dist/index.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "floating-vue/dist/style.css";
import "bootstrap";

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
import { fas as solid } from "@fortawesome/free-solid-svg-icons";
import { far as regular } from "@fortawesome/free-regular-svg-icons";

library.add(solid);
library.add(regular);

app.component("FontAwesomeIcon", FontAwesomeIcon);

// app.use(ElementPlus, {});
(async () => {
  document.addEventListener("DOMContentLoaded", async () => {
    await ApiService.init(app).then(async () => {
      await useUserSettingsStore(pinia).load(UserService.getUser().id);
      initApexCharts(app);
      initInlineSvg(app);
      initVeeValidate();
      app.use(i18n);

      app.use(Toast, {} as PluginOptions);

      app.use(store);
      app.use(router);
      app.use(FloatingVue);
      app.mount("#app");
    });
    // the rest of the code
  });
})();
